export default __webpack_public_path__ + "static/media/growth_icon.b9298223.svg";